// What counts as a photo at the upload edge. Browsers do not agree on HEIC:
// Safari reports image/heic, Windows Chrome reports "" and, with accept
// "image/*" alone, will not even list the file in the picker. So the picker
// accepts by extension too, and the type we send is inferred from the name
// when the browser has nothing to say. The server sniffs bytes regardless.

export const IMAGE_MIME_BY_EXT: Readonly<Record<string, string>> = Object.freeze({
  jpg: "image/jpeg", jpeg: "image/jpeg", jpe: "image/jpeg",
  png: "image/png", gif: "image/gif", webp: "image/webp",
  heic: "image/heic", heif: "image/heif", hif: "image/heif", avif: "image/avif",
  tif: "image/tiff", tiff: "image/tiff", bmp: "image/bmp", dib: "image/bmp",
  svg: "image/svg+xml",
});

/** `accept` for the photo picker: every image type plus the extensions
 *  browsers fail to map to one. */
export const PHOTO_ACCEPT = ["image/*", ...Object.keys(IMAGE_MIME_BY_EXT).map((e) => `.${e}`)].join(",");

export function fileExtension(name: string): string {
  const dot = name.lastIndexOf(".");
  return dot === -1 ? "" : name.slice(dot + 1).toLowerCase();
}

/** The MIME type to declare for an upload. */
export function inferImageMime(file: { name: string; type: string }): string {
  const declared = (file.type || "").toLowerCase().split(";")[0].trim();
  if (declared && declared !== "application/octet-stream") return declared;
  return IMAGE_MIME_BY_EXT[fileExtension(file.name)] ?? (declared || "application/octet-stream");
}

/** Is this something the photo slot should take? */
export function isImageFile(file: { name: string; type: string }): boolean {
  return inferImageMime(file).startsWith("image/");
}
